import {createAction, createReducer} from '@reduxjs/toolkit';

import {STEPS, CURRENT_STEP_KEY} from 'desktop/pages/checkout/constants/checkout';
import {localStore} from 'libs/storage/storage';

import {resetCheckoutSteps} from '../status/status';

export const initialState: STEPS = localStore.get(CURRENT_STEP_KEY) || STEPS.DELIVERY_STEP;

export const setCheckoutStep = createAction<STEPS>('CHECKOUT@SET_CHECKOUT_STEP');

/**
 * Current step
 *
 * @return {string} - new state
 */
export const currentStep = createReducer(initialState, builder =>
    builder
        .addCase(resetCheckoutSteps, () => STEPS.DELIVERY_STEP)
        .addCase(setCheckoutStep, (_, action) => action.payload),
);
